import React from 'react'
import { Form } from 'react-bootstrap'
import Title from 'antd/es/typography/Title';

type Props = {
    title?: string;
    type?: React.HTMLInputTypeAttribute;
    name: string;
    value?: string | number;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    readOnly?: boolean;
    disabled?: boolean;
    rest?: Omit<React.InputHTMLAttributes<HTMLInputElement>, keyof Props>;
}

const InputComp: React.FC<Props> = ({
    title = "",
    type = 'text',
    name,
    value,
    onChange = () => { },
    readOnly = false,
    disabled = false,
    ...rest
}: Props) => {
    return (
        <Form.Group>
            <Title level={5}>{title}</Title>
            <Form.Control
                type={type}
                name={name}
                onChange={onChange}
                value={value}
                readOnly={readOnly}
                disabled={disabled}
                {...rest}
            />
        </Form.Group>
    )
}

export default InputComp